export default {
  "agentDetails.title": "Agent Approval",
  "agentDetails.thead.index": "#No",
  "agentDetails.thead.userno": "Userno",
  "agentDetails.thead.email": "Email",
  "agentDetails.thead.directInviteUserNum": "DirectInviteUserNum",
  "agentDetails.thead.indirectInviteUserNum": "IndirectInviteUserNum",
  "agentDetails.thead.directInviteUserBet": "DirectInviteUserBet",
  "agentDetails.thead.indirectInviteUserBet": "IndirectInviteUserBet",
  "agentDetails.thead.directInviteBonus": "DirectInviteBonus",
  "agentDetails.thead.indirectInviteBonus": "IndirectInviteBonus",
};
